import { render, staticRenderFns } from "./RsaConfigurazioneProfiliLisEditComponent.vue?vue&type=template&id=1347345c"
import script from "./RsaConfigurazioneProfiliLisEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneProfiliLisEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports